import React from 'react';

type Props = {
  color: string
} | typeof defaultProps;

const defaultProps = {
  color: '#424B50',
};

const MailBoxIconV2 = function MailBoxIconV2(props: Props) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_4741_622" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4741_622)">
        <path d="M17.3269 7.91144H15.9942C15.9942 7.27396 15.7134 6.66259 15.2135 6.21182C14.7137 5.76105 14.0357 5.50781 13.3288 5.50781H10.6634C9.95655 5.50781 9.2786 5.76105 8.77874 6.21182C8.27889 6.66259 7.99807 7.27396 7.99807 7.91144H6.66538C6.02134 7.91358 5.39994 8.12594 4.91609 8.50925C4.43223 8.89257 4.11865 9.42091 4.03332 9.99658C4.01188 10.0814 4.00071 10.168 4 10.255V16.3241C4 16.6429 4.14041 16.9486 4.39034 17.1739C4.64026 17.3993 4.97924 17.5259 5.33269 17.5259H18.6596C19.013 17.5259 19.352 17.3993 19.6019 17.1739C19.8519 16.9486 19.9923 16.6429 19.9923 16.3241V10.255C20.0026 10.1691 20.0026 10.0825 19.9923 9.99658C19.9062 9.41577 19.5878 8.88331 19.097 8.49933C18.6061 8.11534 17.9767 7.90628 17.3269 7.91144ZM10.6634 6.70963H13.3288C13.6823 6.70963 14.0213 6.83624 14.2712 7.06163C14.5211 7.28701 14.6615 7.5927 14.6615 7.91144H9.33076C9.33076 7.5927 9.47117 7.28701 9.7211 7.06163C9.97102 6.83624 10.31 6.70963 10.6634 6.70963ZM9.33076 9.11325H17.3269C17.5604 9.1118 17.7901 9.16567 17.9932 9.26949L12.5892 11.577C12.4038 11.6561 12.2012 11.6972 11.9961 11.6972C11.791 11.6972 11.5885 11.6561 11.4031 11.577L5.99903 9.26949C6.20214 9.16567 6.43192 9.1118 6.66538 9.11325H9.33076ZM18.6596 16.3241H5.33269V10.3151L10.8034 12.6526C11.1667 12.812 11.5654 12.8948 11.9695 12.8948C12.3735 12.8948 12.7723 12.812 13.1356 12.6526L18.6596 10.3151V16.3241Z" fill={color} />
      </g>
    </svg>
  );
};
MailBoxIconV2.defaultProps = defaultProps;
export default MailBoxIconV2;
